import { mount } from "@vue/test-utils";
import MoneyLabel from "@/components/core/MoneyLabel";

describe("MoneyLabel test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(MoneyLabel);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component MoneyLabel", () => {
    expect(wrapper).toBeDefined();
  });
});
